import React, { useEffect, useState } from 'react'
import QrReader from 'react-qr-scanner'
import useAppDispatch from '../../../hooks/useAppDispatch'
import useAppSelector from '../../../hooks/useAppSelector'
import { getCameraFacingModeSelector, setCameraFacingMode } from '../../camera/cameraSlice'
import { Box } from '@mui/material'
import CameraSwitchOutlinedIcon from '@mui/icons-material/CameraswitchOutlined'
import { ChronoIconButton } from '@eventops/chronotrack-ctlive-mui'
import { useStyles } from '../../../hooks/useStyles'

export function QrCodeReader({
  handleScan = _ => { },
}) {
  const { classes } = useStyles()
  const dispatch = useAppDispatch()
  const cameraFacingMode = useAppSelector(getCameraFacingModeSelector)
  const [deviceHasMultipleCameras, setDeviceHasMultipleCameras] = useState(false)

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        const videoInputDevices = devices?.filter(d => d.kind === 'videoinput')
        setDeviceHasMultipleCameras(videoInputDevices.length > 1)
      })
      .catch(err => console.error(err))
  }, [])

  function switchCamera() {
    dispatch(setCameraFacingMode(
      cameraFacingMode === 'environment' ? 'user' : 'environment'
    ))
  }

  const handleError = err => console.error(err)

  return (
    <>
        <QrReader
          delay={500}
          className={classes.qrScanner}
          constraints={{
            video: { facingMode: cameraFacingMode }
          }}
          onError={handleError}
          onScan={handleScan}
        />
        {
          deviceHasMultipleCameras &&
          <Box className={classes.qrScannerSwitchCameraButton}>
            <ChronoIconButton onClick={switchCamera} Icon={CameraSwitchOutlinedIcon} />
          </Box>
        }
    </>
  )
}
